module.exports = __webpack_public_path__ + "img/work_bg.51ec0344.png";